export enum BotMessageTypeEnum {
	USER_QUESTION = 'user_question',
	BASIC_ANSWER = 'basic_answer',
	DOCUMENTATION_ANSWER = 'documentation_answer',
	QUESTION = 'question',
	SUGGESTION = 'suggestion',
	NOTIFICATION = 'notification',
	INTRODUCTION= 'introduction',
	SPONTANEOUS_MESSAGE= 'spontaneous_message',
	NO_ANSWER= 'no_answer'
}

export const BotMessageTypeFromIndex: {[id: number]: BotMessageTypeEnum} = {
	0: BotMessageTypeEnum.USER_QUESTION,
	1: BotMessageTypeEnum.BASIC_ANSWER,
	2: BotMessageTypeEnum.DOCUMENTATION_ANSWER,
	3: BotMessageTypeEnum.QUESTION,
	4: BotMessageTypeEnum.SUGGESTION,
	5: BotMessageTypeEnum.NOTIFICATION,
	6: BotMessageTypeEnum.INTRODUCTION,
	7: BotMessageTypeEnum.SPONTANEOUS_MESSAGE,
	8: BotMessageTypeEnum.NO_ANSWER
};
export default BotMessageTypeEnum;
